<template>
    <section>
        <div>
            <b-modal id="alertMsg" hide-footer>
                <span v-html="alertMessage"></span>
            </b-modal>
            <video-poup :videoData="videoData" />
        </div>

        <div class="row">
            <div class="col-md-3 col-sm-12 cus-sidebar">
                <Sidebar />
            </div>
            <div v-if="isLoading" class="loader">
                <div class="wave-container">
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                </div>
                <p>Loading...</p>
            </div>
            <div v-if="!isLoading" class="col-md-9 col-sm-12 right-colm webinar-right-colm">
                <div class="right-content material-box bg-white">
                    <div class="row content-row">
                        <div class="col-md-12 top-title text-left">
                            <h3 class="text-left">Latest Webinars</h3>
                        </div>
                        <div class="col-md-12">
                            <div class="content-colm">
                                <p v-html="webContent.WebinarRegistrationContent1"></p>
                                <p class="bold text-center" style="font-size: 16px; font-weight: bold">
                                    To register for the next Webinar, click on this upcoming week:
                                </p>
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="material-list video">
                                            <ul>
                                                <li v-for="(webinar, index) in webinars" :key="index">
                                                    <template v-if="index < 6">
                                                        <span v-if="getWebinarHtml(webinar) == 'popup'">
                                                            <a @click.prevent="videopoup(webinar.WebinarVimeoLink)">
                                                                Week {{ webinar.WeekNumber }} -
                                                                {{ webinar.WeekName }} -
                                                                {{ formatDate(webinar.WebinarDate) }}
                                                            </a>
                                                        </span>
                                                        <span v-else-if="getWebinarHtml(webinar, index) == 'alert'">
                                                            <a @click.prevent="alertPoup(webinar.WebinarDate)">
                                                                Week
                                                                {{ webinar.WeekNumber }} -
                                                                {{ webinar.WeekName }} -
                                                                {{ formatDate(webinar.WebinarDate) }}</a>
                                                        </span>
                                                        <span v-else-if="getWebinarHtml(webinar, index) == 'link'">
                                                            <a :href="webinar.WebinarLink" target="_blank">
                                                                Week {{ webinar.WeekNumber }} -
                                                                {{ webinar.WeekName }} -
                                                                {{ formatDate(webinar.WebinarDate) }}</a>
                                                        </span>
                                                        <span v-else>
                                                            <a :href="webinar.WebinarLink" target="_blank">
                                                                Week {{ webinar.WeekNumber }} - {{ webinar.WeekName }} -
                                                                {{ formatDate(webinar.WebinarDate) }}
                                                            </a>

                                                        </span>
                                                    </template>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div class="material-list video">
                                            <ul>
                                                <li v-for="(webinar, index) in webinars" :key="index">
                                                    <template v-if="index > 5">
                                                        <span v-if="getWebinarHtml(webinar) == 'popup'">
                                                            <a @click.prevent="videopoup(webinar.WebinarVimeoLink)">
                                                                Week {{ webinar.WeekNumber }} -
                                                                {{ webinar.WeekName }} -
                                                                {{ formatDate(webinar.WebinarDate) }}
                                                            </a>
                                                        </span>
                                                        <span v-else-if="getWebinarHtml(webinar, index) == 'alert'
                                                        ">
                                                            <a @click.prevent="alertPoup(webinar.WebinarDate)">
                                                                Week
                                                                {{ webinar.WeekNumber }} -
                                                                {{ webinar.WeekName }} -
                                                                {{ formatDate(webinar.WebinarDate) }}</a>
                                                        </span>
                                                        <span v-else-if="getWebinarHtml(webinar, index) == 'link'">
                                                            <a :href="webinar.WebinarLink" target="_blank">
                                                                Week {{ webinar.WeekNumber }} -
                                                                {{ webinar.WeekName }} -
                                                                {{ formatDate(webinar.WebinarDate) }}</a>
                                                        </span>
                                                        <span v-else>
                                                            <a :href="webinar.WebinarLink" target="_blank">
                                                                Week {{ webinar.WeekNumber }} -
                                                                {{ webinar.WeekName }} -
                                                                {{ formatDate(webinar.WebinarDate) }}</a>
                                                        </span>
                                                    </template>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="material-box bg-white">
                    <div class="row content-row">
                        <div class="col-md-12 top-title">
                            <h3>Webinar Archives</h3>
                            <!-- <p>
                                DC Trainings provides you with a complete archive of videos,
                                from past Seminars.<br />
                                These videos are broken up into the Weekly segments of the
                                Seminar.
                            </p> -->
                        </div>
                        <div class="content-colm col-md-12" style="margin-bottom: 0px;">
                            <div class="row">
                                <div class="skill-btn archieve-btn" v-for="(archive, index) in archiveModules"
                                    :key="index">
                                    <router-link class="nav-link m-b-5"
                                        :to="{ name: 'WebinarArchive', params: { id: archive.ModuleID } }">Module {{
                                            archive.ModuleNumber }} -
                                        {{ archiveYear(archive.weeks[6].WeekEndDate) }}</router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- end content-row ---->
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Sidebar from "./components/Sidebar.vue";
import userAPI from "../userApi";
import moment from "moment";
import VideoPoup from "./components/VideoPoup.vue";

export default {
    name: "Seminar",
    data() {
        return {
            isLoading: false,
            webContent: [],
            nextModule: [],
            archiveModules: {},
            webinars: {},
            alertMessage: "",
            videoData: {
                videoSrc: ""
            },
        };
    },
    methods: {
        archiveYear(date) {
            console.log(date);
            let nowDate = new Date(moment().format('MM-DD-Y'));
            let mDate = new Date(moment(date).format('MM-DD-Y'));
            let year = moment(date).format("Y");
            if (nowDate > mDate) {
                return year;
            } else {
                return year - 1;
            }
        },
        moduleDate(module, seminar) {
            if (module != null || module != "") {
                return moment(module).format("MMMM, DD Y");
            }
            return moment(seminar).format("MMMM, DD Y");
        },
        upcomingWeekHtml(data) {
            return data;
        },
        getArchivesModules() {
            userAPI.getAllModules(
                (res) => {
                    this.archiveModules = res.data.data;
                },
                (err) => {
                    console.log(err);
                }
            );
        },
        getNextModule() {
            userAPI.getNextModule((res) => {
                this.nextModule = res.data.data;
            });
        },
        getWebContent() {
            this.isLoading = true;
            userAPI.getWebContent(
                (res) => {
                    this.webContent = res.data;
                    this.isLoading = false;

                },
                (err) => {
                    console.log(err);
                    this.isLoading = false;

                }
            );
        },
        getWebinarSchedule() {
            userAPI.getWebinarSchedule(
                (res) => {
                    this.webinars = res.data.data;
                },
                (err) => {
                    console.log(err);
                }
            );
        },
        videopoup(href) {
            this.videoData.videoSrc = 'https://player.vimeo.com/video/' + href;
            this.$bvModal.show("videoModel");
        },
        formatDate(date) {
            return moment(date).format("MMMM DD, YYYY");
        },
        alertPoup(date) {
            let formatDate = moment(date).format("MMMM Do YYYY");
            this.alertMessage = `<div class='' style='height:60px;'><strong><br>This week's Webinar is viewable, beginning at 11:00am, ${formatDate}.</strong></div>`;
            this.$bvModal.show("alertMsg");
        },
        getWebinarHtml(webinar) {
            let playtime = "";
            let linkHtml = "";
            let currentTIme = new Date(moment().format('MMMM D YYYY h:mm:ss a'));
            let webinarTIme = new Date(moment(webinar.WebinarDate).format('MMMM D YYYY h:mm:ss a'));
            let currentdate = new Date(moment().format("MMMM D YYYY"));
            let playdate = new Date(moment(webinar.WebinarDate).format("MMMM D YYYY"));
            if (currentdate == playdate) {
                playtime = "playdate";
            } else if (currentdate > playdate) {
                playtime = "anytime";
            } else if (currentTIme > webinarTIme) {
                playtime = "playdate";
            } else {
                playtime = "notplay";
            }
            if (webinar.IsScottAbsent == 1) {
                if (
                    (playtime == "playdate" && currentTIme <= webinarTIme) ||
                    playtime === "notplay"
                ) {
                    return "alert";
                } else {
                    return "popup";
                }
            } else if (webinar.allow_webinar == 1) {
                let previousWebinar = this.webinars.find((el) => {
                    return el.WebinarID === webinar.WebinarID - 1;
                });
                let previousWebinartime =
                    previousWebinar != undefined
                        ? new Date(moment(previousWebinar.WebinarDate).format('MMMM D YYYY h:mm:ss a'))
                        : "";
                if (
                    previousWebinartime != '' &&
                    currentdate < playdate &&
                    currentTIme > previousWebinartime
                ) {
                    return "link";
                } else {
                    return "popup";
                }
            } else if (webinar.allow_webinar_video == 1) {
                return "popup";
            }
        },
    },
    mounted() {
        this.getWebContent();
        this.getArchivesModules();
        this.getWebinarSchedule();
    },
    components: {
        Sidebar,
        VideoPoup
    },
};
</script>
